import { Image } from '@phosphor-icons/react';

export default Image;
